import { render, staticRenderFns } from "./DispensacionFaltantes.vue?vue&type=template&id=21a254c4&scoped=true"
import script from "./DispensacionFaltantes.vue?vue&type=script&lang=js"
export * from "./DispensacionFaltantes.vue?vue&type=script&lang=js"
import style0 from "./DispensacionFaltantes.vue?vue&type=style&index=0&id=21a254c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a254c4",
  null
  
)

export default component.exports